export const GET_CALL_LOGS = 'GET_CALL_LOGS';
export const ADD_CALL_LOG = 'ADD_CALL_LOG';
export const ERROR_ADDING_CALL_LOG = 'ERROR_ADDING_CALL_LOG';
